import React from 'react'
import MaterialSymbol from '../material-symbol'

const AssignmentTurnedIn = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="assignment_turned_in" {...props} />
))

AssignmentTurnedIn.displayName = 'AssignmentTurnedIn'

export default AssignmentTurnedIn
